<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailRemiseBancaire.informations.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field :label="$t('detailRemiseBancaire.informations.libelle')"
                 class="column is-3"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ remiseBancaire.nom }}
            </span>
        </b-field>
        <b-field :label="$t('detailRemiseBancaire.informations.dateRemise')"
                 class="column is-3"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ remiseBancaire.dateRemise | formatDate }}
            </span>
        </b-field>
        <b-field :label="$t('detailRemiseBancaire.informations.banque')"
                 class="column is-3"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getLibelleDomiciliationBancaire }}
            </span>
        </b-field>
        <b-field :label="$t('detailRemiseBancaire.informations.modeReglement')"
                 class="column is-3"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getLibelleModeReglement }}
            </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    remiseBancaire: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getLibelleDomiciliationBancaire() {
      const domFind = this.parametre(PARAMETRES_KEYS.domiciliationBancaire)
        .find((domicialisation) => {
          return domicialisation.id === this.remiseBancaire.domiciliationBancaireId;
        });
      return domFind ? domFind.libelleBanque + ' (' + domFind.libelle + ')' : null;
    },
    getLibelleModeReglement() {
      const modeReglementFind = this.parametre(PARAMETRES_KEYS.modeReglement)
        .find((modeReglement) => {
          return modeReglement.id === this.remiseBancaire.modeReglementId;
        });
      return modeReglementFind ? modeReglementFind.libelle : null;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.loadParametres([
        PARAMETRES_KEYS.domiciliationBancaire,
        PARAMETRES_KEYS.modeReglement,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
